module.exports = __webpack_public_path__ + "static/media/history.81ecd9d1.svg";